import { defineAsyncComponent } from 'vue'

export enum SMSGlobalRouteName {
    Index = 'sms-global.index',
    SettingsIndex = 'sms-global.settings.index',
    SettingsFormSchema = 'sms-global.settings.form-schema',
    ServerShow = 'sms-global.server.show',
    ServerSMSIndex = 'sms-global.server.sms.index',
    ServerSMSCreate = 'sms-global.server.sms.create',
}

export default {
    routes: [
        {
            path: '/sms-global',
            name: SMSGlobalRouteName.Index,
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'SMSGlobal',
                icon: 'fal fa-comment-sms fa-fw',
                permission: 'manage-sms-global',
                auth: true,
                module: 'metatech/smsglobal',
            },
            children: [
                // {
                //     path: 'settings',
                //     name: SMSGlobalRouteName.SettingsIndex,
                //     component: () => import('./views/settings/Index.vue'),
                //     meta: {
                //         label: 'Settings',
                //         permission: 'manage-sms-global',
                //     },
                //     children: [
                //         {
                //             path: 'form-schema',
                //             name: SMSGlobalRouteName.SettingsFormSchema,
                //             component: () => import('./views/settings/form-schema/Index.vue'),
                //             meta: {
                //                 label: 'Form Schema',
                //                 permission: 'manage-sms-global',
                //             },
                //             children: [],
                //         },
                //     ],
                // },
                {
                    path: 'servers/:serverId',
                    name: SMSGlobalRouteName.ServerShow,
                    component: () => import('./views/server/Show.vue'),
                    meta: {
                        label: 'Server',
                        permission: 'manage-sms-global',
                    },
                    children: [
                        {
                            path: 'sms',
                            name: SMSGlobalRouteName.ServerSMSIndex,
                            component: () => import('./views/server/sms/Index.vue'),
                            meta: {
                                label: 'SMS',
                                icon: 'message-sms',
                                permission: 'manage-sms-global',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: SMSGlobalRouteName.ServerSMSCreate,
                                    component: () => import('./views/server/sms/Index.vue'),
                                    meta: {
                                        label: 'Create',
                                        icon: 'message-sms',
                                        permission: 'manage-sms-global',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
}
